import { __DEV__ } from "~/config";
import { DevDetails, ErrorActions, ErrorIcon } from "./components";
import { ErrorPageProps } from "./types";
import {
  getDevelopmentErrorInfo,
  getErrorStatus,
  getProductionMessage,
} from "./utils";

const DEFAULT_ERROR_PLACEHOLDER = "Unknown error (no error object provided)";

export function ErrorPage({ error, status }: ErrorPageProps) {
  const isDev = __DEV__;

  // Get user-friendly message (for production and dev)
  const { message: userMessage, details: userDetails } = getProductionMessage(
    error,
    status,
  );

  // Get detailed error info for development - show even if error is undefined/null if we have status
  const devErrorInfo =
    isDev && (error !== undefined || status !== undefined)
      ? getDevelopmentErrorInfo(error ?? DEFAULT_ERROR_PLACEHOLDER, status)
      : null;

  // For display purposes
  const displayMessage =
    isDev && devErrorInfo ? devErrorInfo.devTitle : userMessage;
  const errorStatus = getErrorStatus(error, status);

  return (
    <main className="container mx-auto flex min-h-screen flex-col py-10">
      {!isDev && (
        <div className="my-auto text-center">
          <ErrorIcon />
          {/* Error Title */}
          <h1 className="font-playfair text-night mb-4 text-4xl font-bold">
            {errorStatus || displayMessage}
          </h1>
          {/* Error Message */}
          <p className="mb-8 text-lg text-gray-600 md:text-xl">{userDetails}</p>
          <ErrorActions />
        </div>
      )}

      <DevDetails
        error={error}
        status={status}
        isDev={isDev}
        devErrorInfo={devErrorInfo}
      />
    </main>
  );
}
